const actions = {
  // NOTIFICATIONS ERROR popups ---------------------------------------
  // async errorClearingAllNotifications({dispatch}, data) {
  //   let { allCleared } = data
  //   dispatch('popups/show/error', {
  //     message: `${allCleared} notification${
  //       allCleared > 1 ? 's' : ''
  //     } couldn't be cleared because ${
  //       allCleared > 1 ? 'they haven\'t' : 'it hasn\'t'
  //     } been responded to yet.`
  //   }, {root: true})
  // },
  async errorInviteFailed({dispatch}) {
    dispatch('popups/show/error/custom', 'sending this invite', {root: true})
  },
  // NOTIFICATIONS CONFIRM popups --------------------------------------
  async confirmJumpSpaceInvite({dispatch}, data) {
    dispatch('popups/show/confirm', {
      message: data.title,
      description: data.message,
      buttons: [
        {
          name: 'Cancel',
          id: 'cancel',

          function: 'close'
        },
        {
          name: 'Okay',
          id: 'confirm',
          colour: 'green',

          function: async () => data.submitForm()
        }
      ]
    }, {root: true})
  },

  // BROADCAST CONFIRM popups ------------------------------------------
  async confirmAddBroadcast({dispatch}, data) {
    console.log(data)
    dispatch('popups/show/confirm', {
      message: data.data.title,
      description: data.data.message,
      icon: 'broadcast',
      buttons: [
        {
          name: 'Back',
          id: 'edit',

          function: 'close'
        },
        {
          name: 'Broadcast',
          id: 'confirm',
          colour: 'green',

          function: async () => data.submitForm()
        }
      ]
    }, {root: true})
  },
  async confirmDeleteBroadcast({dispatch}, data) {
    let { callback } = data
    dispatch('popups/show/confirm', {
      message: 'Are you sure you want to remove this broadcast?',
      buttons: [
        {
          id: 'confirm',
          name: 'Yes',
          colour: 'red',
          textColour: '#FFF',
          function: callback
        },
        {
          id: 'cancel',
          name: 'No',
          textColour: '#FFF',
          function: 'close'
        }
      ]
    }, {root: true})
  },
  async displayBroadcastMessage({dispatch}, data) {
    let { title,message } = data
    dispatch('popups/show/confirm', {
      message: title,
      description: message,
      icon: 'broadcast',
      buttons: [
        {
          name: 'Dismiss',
          id: 'dismiss',
          colour: 'green',

          function: () => dispatch('hideBroadcast', data, {root:true})
        }
      ]
    }, {root: true})
  },
  // BROADCAST SUCCESS popups --------------------------------------
  async successDeletingBroadcast({dispatch}) {
    dispatch('popups/show/success/deleting', 'Broadcast', {root: true})
  },
};

export default {
  namespaced: true,
  actions
};
